import { render, staticRenderFns } from "./BonusDetailCard.vue?vue&type=template&id=2a31da3c&"
import script from "./BonusDetailCard.vue?vue&type=script&lang=js&"
export * from "./BonusDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports